<template>
    <ErrorPage code="404" status="Not Found" :href="$urls.APP_HOME" href-text="Go to Gears App"/>
</template>

<script>
    import ErrorPage from "../components/ErrorPage";

    export default {
        name: "ErrorNotFound",
        components: {ErrorPage},
    }
</script>

<style scoped>

</style>
